import React from "react";
import { Routes, Route } from "react-router-dom";
import { ClassroomProvider } from "./contexts/classroom.context";
import { Classrooms } from "./screens/Classrooms";
import { BaseRoute } from "../routing/PrivateRoute";
import { CreateClassroom } from "./screens/CreateClassroom";
import { ViewClassroom } from "./screens/ViewClassroom";
import { FetchProvider } from "../../core/components/crud/contexts/fetch.context";
import { get } from "../../client/api/classroom";
import { get as getProgramme } from "../../client/api/programme";
import { ProgrammeProvider } from "../programme/contexts/programme.context";
import { CreateClassProgramme } from "./screens/CreateClassProgramme";
import { SelectClassroomForProgramme } from "./screens/SelectClassroomForProgramme";
import { ViewClassProgramme } from "./screens/ViewClassProgramme";
//import { ClassSessionScreen } from "./session/ClassSessionScreen";

export const ClassroomScreen = (): JSX.Element => {
    return (
        <ClassroomProvider>
            <FetchProvider noun="Classroom" getItem={get}>
                <Routes>
                    <Route path="/" element={<BaseRoute permission={"ClassroomView"} component={Classrooms} />} />
                    <Route
                        path="/add"
                        element={<BaseRoute permission={"ClassroomCreate"} component={CreateClassroom} />}
                    />
                    <Route
                        path="/create-programme"
                        element={<BaseRoute permission="ProgrammeCreate" component={SelectClassroomForProgramme} />}
                    />
                    <Route
                        path="/view/:id/add/:paramId?"
                        element={
                            <ProgrammeProvider>
                                <BaseRoute permission="ProgrammeCreate" component={CreateClassProgramme} />
                            </ProgrammeProvider>
                        }
                    />
                    <Route
                        path="/view/:id/view/:programmeId"
                        element={
                            <ProgrammeProvider>
                                <FetchProvider noun="Programme" getItem={getProgramme}>
                                    <BaseRoute permission="ProgrammeView" component={() => <ViewClassProgramme />} />
                                </FetchProvider>
                            </ProgrammeProvider>
                        }
                    />
                    <Route
                        path="/view/:id/*"
                        element={<BaseRoute permission="ClassroomView" component={ViewClassroom} />}
                    />
                </Routes>
            </FetchProvider>
        </ClassroomProvider>
    );
};
